import base64url from 'base64url';

import { CustomerWithUserCustomers, CustomerWithUserCustomersFromJSON } from '../models/CustomerWithUserCustomers';
import { BaseEntityQueryParams } from '../models/EntityQueries';
import { EntityQueryResults, EntityQueryResultsFromJSON } from '../models/EntityQueryResults';
import { Organization, OrganizationFromJSON, OrganizationToJSON } from '../models/Organization';
import * as runtime from '../runtime';
import { getCustomerVariables } from '../../features/context/CustomerContextHelper';
import { CustomerVariables } from '../../customerVariables/variable_interfaces';

export class OrganizationsApi extends runtime.BaseAPI {

    readonly customerVariables: CustomerVariables = getCustomerVariables();

    /**
 * Gets all organizations
 */
    async getOrganizationsRaw(requestParameters: BaseEntityQueryParams): Promise<runtime.ApiResponse<EntityQueryResults<Organization>>> {
        const queryParameters: any = {};

        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize
        }

        if (requestParameters.sort !== undefined && requestParameters.sort !== "") {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.filter !== undefined && requestParameters.filter !== null && requestParameters.filterParam !== undefined && requestParameters.filterParam !== null) {
            queryParameters[requestParameters.filter] = requestParameters.filterParam;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/realms/${this.customerVariables.realmName}/wapice/organizations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EntityQueryResultsFromJSON(jsonValue, OrganizationFromJSON));

    }

    /**
     * Gets all organizations
     */
    async getOrganizations(requestParameters: BaseEntityQueryParams): Promise<EntityQueryResults<Organization>> {
        const response = await this.getOrganizationsRaw(requestParameters);
        return await response.value();
    }

    async getOrganizationCustomersRaw(organization: string):Promise<runtime.ApiResponse<CustomerWithUserCustomers[]>> {

        if (organization === null || organization === undefined || organization === '') {
            throw new runtime.RequiredError('organization', 'Required parameter organization was null or undefined when calling delete.');
        }

        const queryParameters: any = {};

        if(organization.includes("/")){
            organization = base64url.encode(organization);
            queryParameters['urlPathParamEncoding'] = "base64url";
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/realms/${this.customerVariables.realmName}/wapice/organizations/${organization}/customers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerWithUserCustomersFromJSON));
    }

    async getOrganizationCustomers(organization: string): Promise<CustomerWithUserCustomers[]> {
        const response = await this.getOrganizationCustomersRaw(organization);
        return await response.value();
    }

    /**
    * Update or add new organization
    */
    async update(organization: Organization) {
        await this.updateRaw(organization);
        }
    
    async updateRaw(organization: Organization): Promise<runtime.ApiResponse<void>> {
        if (organization === null || organization === undefined) {
            throw new runtime.RequiredError('organization', 'Required parameter organization was null or undefined when calling update.');
        }
    
        const headerParameters: runtime.HTTPHeaders = {};
    
        headerParameters['Content-Type'] = 'application/json';
    
        const response = await this.request({
            path: `/realms/${this.customerVariables.realmName}/wapice/organizations`,
            method: 'PUT',
            headers: headerParameters,
            body: OrganizationToJSON(organization)
            });
    
        return new runtime.VoidApiResponse(response);
    }
}